"use strict";

(() => {
    class FreeShippingNote extends HTMLElement {
        constructor(){
            super();
            if(!_theme.freeShipping || !window._theme.cartjson) return;

            this.config = Object.assign({}, _theme.freeShipping);
            this.cart = window._theme.cartjson;
            _theme.freeShipNode = this;
            this.moneyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });  
            this.freeShipNote = this.querySelector('.free-ship-note');
            this.freeShipProgressBar = this.querySelector('.free-ship-progress-bar');

            this.render(this.cart);
            delete _theme.freeShipping;
        }

        render = cart => {
            if(!cart || !this.config.threshold) return;
            if(!this.config.preText || !this.config.postText) return;

            if(cart.item_count === 0){
                this.setAttribute('data-hidden', true);
                return;
            }

            this.removeAttribute('data-hidden');
            const cartTotal = (cart.total_price/100);
            const diff = this.config.threshold - cartTotal;
            if(diff > 0){
                const diffMoneyFormat = this.moneyFormat.format(diff);
                const progress = (100 - ((diff*100) / this.config.threshold)).toFixed(2);
                this.freeShipNote.innerHTML = this.config.preText.replace('$x', diffMoneyFormat);
                this.freeShipProgressBar.style.setProperty('--freeship-progress', `${progress}%`);
            } else {
                this.freeShipNote.innerHTML = this.config.postText;
                this.freeShipProgressBar.style.setProperty('--freeship-progress', '100%');
            }
        }
    }

    if(!customElements.get('free-shipping-note')){
        customElements.define('free-shipping-note', FreeShippingNote);
    }
})();